import './App.css';
import AllLinks from './Routes/AllLinks';



function App() {
  return (
    <div className="App">
      <AllLinks />
    </div>
  );
}

export default App;